import './App.css';

import React from 'react';
import { Outlet, Route, Routes } from 'react-router';

import { ROUTES } from '@/constants/config';
import useDepartments from '@/hooks/useDepartments';
import ViewsPage from '@/pages/views/Views.page';
import { useAppSelector } from '@/store/hooks';

import ProtectedRoute from './components/protected-route/ProtectedRoute';
import PersonnelPage from './pages/personnel/Personnel.page';
import UnauthorizedPage from './pages/unauthorized/Unauthorized.page';

const App = (): React.JSX.Element => {
  const fetchDepartments = useDepartments();
  const { isAuthenticated } = useAppSelector((state) => state.auth);

  React.useEffect(() => {
    if (!isAuthenticated) return;

    fetchDepartments();
  }, [fetchDepartments, isAuthenticated]);

  return (
    <>
      <Routes>
        <Route
          path={ROUTES.PERSONNEL}
          element={
            <ProtectedRoute>
              <PersonnelPage />
            </ProtectedRoute>
          }
        />
        <Route path={ROUTES.UNAUTHORIZED} element={<UnauthorizedPage />} />
        {[ROUTES.VIEWS, ROUTES.ROOT, `${ROUTES.EDIT}/:viewId`].map((path) => (
          <Route
            element={
              <ProtectedRoute>
                <ViewsPage />
              </ProtectedRoute>
            }
            key={path}
            path={path}
          />
        ))}
        <Route path={'*'} element={<UnauthorizedPage />} />
      </Routes>
      <Outlet />
    </>
  );
};

export default App;
